import { AxiosInstance } from 'axios';

import { ShareInvitation, ShareTypes, SharingPartner } from './sharing.types';

const SharingServiceFactory = ({ HTTPProfileManager }: { HTTPProfileManager: AxiosInstance }) => {
  return {
    getShares: (id?: string): Promise<SharingPartner[]> =>
      HTTPProfileManager.get(`shares/${id || 'me'}?shareType=${ShareTypes.FEED_SET}`).then((res) => res.data),
    deleteShare: (id: string): Promise<any> => HTTPProfileManager.delete(`shares/${id}`).then((res) => res.data),
    updateShare: (id: string): Promise<any> => HTTPProfileManager.patch(`shares/${id}`).then((res) => res.data),
    postShare: (invitation: ShareInvitation): Promise<any> =>
      HTTPProfileManager.post('shares', invitation).then((res) => res.data),
    acceptInvitation: (inviteToken: string): Promise<any> =>
      HTTPProfileManager.post('shares/invite', { inviteToken }).then((res) => res.data),
  };
};

export default SharingServiceFactory;
